import React, { Component } from 'react';
import styles from './Invalid.module.css';
export default class InvalidModule extends Component {
    render() {
        return <div className="col-md-10 offset-md-1">
            <div className={`card ${styles['text-center']}`}>
                <div className="card-header">Invalid Module</div>
                <div className="card-body">
                    <h5 className="card-title">The module you access is invalid or do not exist</h5>
                </div>
            </div>
        </div>
    }
};